<router-outlet></router-outlet>
<ngx-spinner
  template="<img class='loader-image mr-1' src='assets/img/loader.svg' />
  <span class='loader'></span>"
></ngx-spinner>